// contains common functions -- used in multiple places in the system manager
import { STATUS_CHANNEL_BASE, CHECKPOINT_CHANNEL_BASE } from "./_constants";

/**
 * Function to return the name of a startup status channel, given the window name
 * @param name
 * @returns
 */
export function statusChannel(name) {
	return `${STATUS_CHANNEL_BASE}.${name}`;
}

/**
 * Function to return the name of a checkpoint status channel, given the parent name (e.g. service name, component name) and the checkpoint name
 * @param parentName
 * @param checkpointName
 * @returns
 */
export function checkpointChannel(parentName, checkpointName) {
	return `${CHECKPOINT_CHANNEL_BASE}.${parentName}.${checkpointName}`;
}
